
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12187',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12187",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "dashboard-client-types": "static-1.370",
  "data-fetching-client": "static-1.9657",
  "foundations-components": "static-1.7903",
  "foundations-components-legacy": "static-1.928",
  "foundations-theming": "static-1.4405",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.81",
  "head-dlb": "static-1.4994",
  "hs-test-utils": "static-1.8000",
  "hub-http-shared-msw-handlers": "static-1.9920",
  "hubspot-dlb": "static-2.1845",
  "hubspot-url-utils": "static-1.4115",
  "HubStyleTokens": "static-2.11455",
  "I18n": "static-7.1621",
  "jasmine-runner": "static-1.6453",
  "marketplace-storefront-base": "static-1.12248",
  "quartz": "static-1.7014",
  "react-dlb": "static-1.78",
  "react-rhumb": "static-1.16654",
  "reactive-variable-buffer-atom": "static-1.2845",
  "reporting-testing-lib": "static-1.9400",
  "settings-ui-lib": "static-1.12506",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7102",
  "ui-addon-i18n": "static-1.11138",
  "ui-addon-react-router-dom": "static-1.9531",
  "unified-auth": "static-1.475",
  "unified-auth-core-lib": "static-1.757",
  "usage-tracker": "static-1-cwunder-network-layer-chunking-backpressure.8",
  "usage-tracker-core": "static-1-cwunder-network-layer-chunking-backpressure.8",
  "customer-data-property-utils": "static-1.8075",
  "hub-http": "static-1.6210",
  "integrations-lib": "static-1.16061",
  "marketplace-ui-common": "static-1.19653",
  "property-management-iframe": "static-1.13082",
  "quartz-config": "static-1.792",
  "quartz-core": "static-1.6233",
  "quartz-routing": "static-1.444",
  "quick-fetch": "static-1.3905",
  "react": "static-7.185",
  "rpc-client-utils": "static-1.4637",
  "ts-schema": "static-1.4069",
  "ui-universal-auth": "static-1.8961",
  "UIComponents": "static-3.8401",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.446",
  "hs-promise-rejection-tracking": "static-1.5566",
  "PortalIdParser": "static-2.397",
  "raven": "static-3.5907",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9619",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3389",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3291",
  "quartz-webpack": "static-1.3238",
  "bend-plugin-quartz-routing": "static-1.92",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4172",
  "floating-ui": "static-1.55",
  "foundations-assets": "static-1.4852",
  "foundations-theming-specialty": "static-1.2121",
  "framer-motion": "static-1.71",
  "hs-story-utils": "static-1.9413",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.19",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5333",
  "react-virtualized": "static-2.98",
  "StyleGuideUI": "static-3.486",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1861",
  "ui-fonts": "static-1.717",
  "ui-images": "static-2.1149",
  "bend-plugin-foundations-theming": "static-1.2888",
  "foundations-theming-base": "static-1.3390",
  "stylex": "static-1.32",
  "HeadJS": "static-2.757",
  "hs-test-utils-bend-plugin": "static-1.3111",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4314",
  "ai-components-ui-library": "static-1.8898",
  "ai-rendering-library": "static-1.10088",
  "chirp-fetch": "static-1.1872",
  "connections-embed-lib": "static-1.957",
  "copilot-toolkit": "static-1.11091",
  "feedback-loader": "static-1.29264",
  "laboratory-lib": "static-3.7145",
  "marketplace-embed": "static-1.22028",
  "marketplace-ui-details": "static-1.9549",
  "marketplace-ui-reviews": "static-1.19609",
  "marketplace-ui-tracking": "static-1.13824",
  "sanitize-text": "static-1.8128",
  "ui-addon-video-player": "static-1.8689",
  "usage-tracker-multi": "static-1-cwunder-network-layer-chunking-backpressure.8",
  "usage-tracker-session-replay": "static-1-cwunder-network-layer-chunking-backpressure.8",
  "wootric-nps": "static-1.6964",
  "quartz-head": "static-1.679",
  "web-vitals": "static-1.4",
  "apollo-link-hub-http": "static-2.4636",
  "immer": "static-1.33",
  "immerable": "static-1.4141",
  "highcharts": "static-8.103",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2496",
  "reporting-data": "static-1.67467",
  "cssUtils": "static-1.787",
  "flux-actions": "static-1.336",
  "HubStyle": "static-2.11762",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10196",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10355",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1-cwunder-network-layer-chunking-backpressure.8",
  "icons": "static-2.645",
  "marketplace-ui-apps-core": "static-1.18186",
  "storybook-react": "static-1.32",
  "trellis-story-utils": "static-1.4503",
  "foundations-components-test-utils": "static-1.5386",
  "quartz-i18n": "static-1.689",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.180",
  "microsoft-drive-integration-lib": "static-1.298",
  "fsm": "static-1.3718",
  "customer-data-objects": "static-1.7652",
  "property-translator": "static-1.5386",
  "hs-locale-management": "static-1.70",
  "frontend-preferences-client": "static-1.7916",
  "hs-promise-utils": "static-1.5581",
  "hubspot-apollo-client": "static-1.4864",
  "integrations-error-boundary-lib": "static-1.13476",
  "integrations-tracking-lib": "static-1.5586",
  "native-integrations-shared-strings": "static-1.7769",
  "reselect": "static-2.16",
  "sanitize": "static-1.4463",
  "superstore": "static-1.4750",
  "ui-shepherd-react": "static-3.10145",
  "ai-settings-ui-library": "static-1.7861",
  "hub-http-janus": "static-1.830",
  "hubspotter-http": "static-1.4641",
  "immutable-less": "static-1.4641",
  "marketplace-ui-client-types": "static-1.17060",
  "nav-meta": "static-1.29616",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10235",
  "ui-addon-upgrades": "static-9.17963",
  "inbound-db-properties-service-client": "static-1.3835",
  "property-management-common": "static-1.5370",
  "ui-addon-iframeable": "static-1.9042",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.532",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.689",
  "quartz-test": "static-1.689",
  "quartz-tracking": "static-1.393",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.47",
  "bender-build-tools": "static-1.3186",
  "usage-tracker-anonymous": "static-1-cwunder-network-layer-chunking-backpressure.8",
  "usage-tracker-public": "static-1-cwunder-network-layer-chunking-backpressure.8",
  "amplitude-session-replay-browser": "static-1.59",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21208",
  "ContentUtils": "static-1.68306",
  "customer-data-objects-ui-components": "static-1.13011",
  "sassPrefix": "static-1.155",
  "avatar-components": "static-1.2485",
  "customer-data-filters-ui": "static-1.39692",
  "customer-data-reference-ui-components": "static-1.13147",
  "embedded-academy-lib": "static-1.14274",
  "ExportDialog": "static-6.10378",
  "highlight.js": "static-1.78",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41254",
  "reporting-snowflake": "static-1.56085",
  "reporting-ui-components": "static-2.64738",
  "reporting-visualizations": "static-1.59543",
  "ui-addon-teams": "static-1.21523",
  "magpie-lib": "static-1.5543",
  "navigation-components": "static-1.17979",
  "magpie-types": "static-1.5003",
  "simple-logging-lib": "static-1.3035",
  "ai-studio-lib": "static-1.11556",
  "app-governance-lib": "static-1.1481",
  "developer-experience-shared-components": "static-1.10496",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7982",
  "ui-product-approvals": "static-1.28093",
  "ui-tool-access": "static-1.10136",
  "usage-based-billing-components-lib": "static-1.8810",
  "inbound-db-meta-service-client": "static-1.3575",
  "persist-promise": "static-1.3684",
  "reference-resolvers": "static-1.8156",
  "ui-extensibility-client-types": "static-1.3916",
  "hubspot-apollo-cache": "static-1.323",
  "universal-page-editor-lib": "static-1.3000",
  "final-form": "static-1.69",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2724",
  "merchandise-lib": "static-1.263",
  "atom": "static-1.5057",
  "purchase-motions-components": "static-1.5855",
  "salesImages": "static-1.524",
  "batch-promise": "static-1.1527",
  "crm-component-utils": "static-1.39017",
  "crm-properties-common-lib": "static-1.5869",
  "customer-data-properties": "static-1.51477",
  "framework-data-schema-resolvers": "static-1.6870",
  "property-value-citations": "static-1.2091",
  "reference-resolvers-lite": "static-1.8080",
  "navigation-messaging": "static-1.7306",
  "hubspotter-http-shared-msw-handlers": "static-1.9918",
  "cms-field-types": "static-1.4797",
  "content-icons-ui": "static-1.2221",
  "customer-data-ui-utilities": "static-1.9812",
  "events-data-lib": "static-1.203",
  "conversations-skeleton-state": "static-1.7233",
  "crm-message-bus": "static-1.42932",
  "customer-data-filters-ui-msw-helpers": "static-1.22127",
  "FormUrlGenerator": "static-2.4704",
  "framework-builder-read-service-client": "static-1.3994",
  "framework-data-schema-quick-fetch": "static-1.6775",
  "multi-account-reference-resolvers": "static-1.965",
  "onboarding-tours": "static-1.16565",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13628",
  "academy-common-lib": "static-1.13734",
  "content-assistance-lib": "static-1.7728",
  "dashboard-lib": "static-1.81456",
  "file-manager-components": "static-1.23571",
  "getting-started-shared-tasks": "static-1.18451",
  "hubspot-prosemirror": "static-1.18193",
  "hubspot-prosemirror-plugins": "static-1.18185",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19799",
  "share-with-third-party-component-lib": "static-1.8691",
  "ui-addon-draggable": "static-3.4752",
  "ui-asset-management-lib": "static-1.11003",
  "ui-business-units-lib": "static-1.9036",
  "user-context": "static-1.5090",
  "growth-payments-core": "static-1.25319",
  "reporting-plugins": "static-1.10298",
  "reporting-reports": "static-1.67145",
  "idb-keyval": "static-1.43",
  "reactive-lib": "static-1.709",
  "nest": "static-1.212",
  "codemirror": "static-5.94",
  "react-codemirror": "static-1.10612",
  "framework-listing-lib": "static-2.28642",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30673",
  "apps-service-types": "static-1.3865",
  "oauth-service-types": "static-1.4235",
  "onboarding-scopes": "static-1.6448",
  "onboarding-tours-client": "static-1.4779",
  "platform-infra-nav-components": "static-1.7658",
  "subscription-experience-data-types": "static-1.14910",
  "crm-record-cards-service-types": "static-1.3587",
  "location-customization-utils-lib": "static-1.9194",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5858",
  "signup-constants": "static-1.18811",
  "signup-ui-url-generator": "static-2.8032",
  "trials-service-types": "static-1.3890",
  "card-properties-lib": "static-1.44123",
  "commerce-subscription-lib": "static-1.37053",
  "crm-actions": "static-1.6309",
  "crm-cards-sdk": "static-1.43526",
  "customer-data-properties-shared-msw-handlers": "static-1.9247",
  "customer-data-tracking": "static-1.6874",
  "hs-resources": "static-1.142",
  "pulse": "static-1.560",
  "calling-global-api": "static-1.64451",
  "calling-internal-common": "static-1.31287",
  "calling-lifecycle-internal": "static-1.65833",
  "calling-lifecycle-messages": "static-1.58127",
  "commerce-products-lib": "static-1.9494",
  "conditional-properties-service-client": "static-1.3786",
  "crm-links": "static-1.6273",
  "external-options-client-types": "static-1.4147",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4212",
  "meetings-icalendar-utils-lib": "static-1.617",
  "multi-currency-client-types": "static-1.3680",
  "object-builder-ui-client": "static-1.48675",
  "pipeline-validation-client-types": "static-1.3954",
  "smart-property-lib": "static-1.6862",
  "tiered-pricing": "static-1.1169",
  "ui-addon-form-validation": "static-1.10980",
  "crm-pipelines-api-client-types": "static-1.4127",
  "react-dnd-compat": "static-1.4604",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5405",
  "growth-onboarding-confetti": "static-1.3053",
  "growth-onboarding-next-action-utils": "static-1.1867",
  "onboarding-tours-utils": "static-1.631",
  "ui-shepherd-tracker": "static-1.7526",
  "academy-service-client": "static-1.3668",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39070",
  "FileManagerLib": "static-1.39211",
  "video-embed": "static-1.35699",
  "zustand": "static-1.74",
  "ui-coaching-tips": "static-1.28498",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11207",
  "video-data-lib": "static-1.34865",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23482",
  "ui-addon-emoji-picker": "static-1.9875",
  "EmailSignatureEditor": "static-1.24329",
  "viral-links-lib": "static-1.7046",
  "data-token-picker": "static-1.16378",
  "react-flip-move": "static-1.69",
  "nested-table": "static-1.213",
  "timezone-utils": "static-2.5230",
  "getting-started-shared-tasks-store": "static-1.17569",
  "ui-addon-opt": "static-4.8357",
  "campaign-roi-lib": "static-1.9040",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7312",
  "customer-data-views-management": "static-1.25418",
  "framework-data-table": "static-2.11870",
  "marketing-platform-lib": "static-1.6841",
  "nudge-client-utils": "static-1.2530",
  "nudge-custom-ui-functions": "static-1.1003",
  "app-users-service-client": "static-1.5583",
  "app-users-service-types": "static-1.4991",
  "mini-checkout-client": "static-1.26766",
  "onboarding-utils": "static-1.5339",
  "permissions-shared-i18n-strings-fe": "static-1.2045",
  "ui-coaching-tips-shared-config": "static-1.28483",
  "edison-service-client-types": "static-1.374",
  "crm_data": "static-4.91903",
  "customer-data-sidebar": "static-2.45961",
  "enrichment-properties-lib": "static-1.15980",
  "commerce-billing-lib": "static-1.19012",
  "commerce-shared-components-lib": "static-1.18493",
  "commerce-tools-ui-lib": "static-1.10324",
  "crm-fe-perf": "static-1.22889",
  "bend-plugin-pulse": "static-1.63",
  "directed-graph": "static-1.921",
  "event-emitter": "static-1.934",
  "fast-json-patch": "static-1.62",
  "calling-error-reporting": "static-1.31294",
  "shared-worker-versioning": "static-1.11024",
  "calling-usage-tracker": "static-1.6527",
  "voice-sms-access-library": "static-1.911",
  "commerce-permissions": "static-1.755",
  "products-iframe-lib": "static-1.7882",
  "products-ui-components-shared-msw-handlers": "static-1.10302",
  "data-agent-kit": "static-1.171",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10003",
  "policy-lib": "static-1.6767",
  "react-tinymce": "static-1.55190",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10066",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54316",
  "tinymce-plugins": "static-1.57430",
  "tinymce-themes": "static-1.56286",
  "onboarding-data-sync-lib": "static-1.1933",
  "growth-onboarding-next-action-components": "static-1.1895",
  "user-context-client": "static-1.4598",
  "audio-components": "static-1.5892",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36722",
  "urlinator": "static-1.4523",
  "video-components": "static-1.13210",
  "outpost": "static-1.4171",
  "growth-onboarding-feedback-components": "static-1.6568",
  "content-media-composition-data-lib": "static-1.12196",
  "content-media-compositions": "static-2.16203",
  "media-bridge-lib": "static-1.18896",
  "commerce-tours-lib": "static-1.6063",
  "growth-onboarding-reliability": "static-1.5068",
  "sales-checkout-service-client": "static-1.3627",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21644",
  "sales-email-signature-service-client": "static-1.3829",
  "ts-utils-lib": "static-1.159",
  "breeze-engine-lib": "static-1.566",
  "crm-export-dialog": "static-1.6283",
  "crm-index-associations-lib": "static-1.6427",
  "crm-view-components": "static-1.181",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.29",
  "nudge-custom-function-registry": "static-1.2287",
  "nudge-renderer-utils": "static-1.2606",
  "whisper-core-api": "static-1.6566",
  "InboxConnectUtils": "static-4.14763",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5475",
  "settings-content-modals": "static-1.46023",
  "crm_universal": "static-1.21977",
  "customer-data-email": "static-1.18004",
  "card-payment-highlight-lib": "static-1.37119",
  "card-subscription-highlight-lib": "static-1.39476",
  "commerce-contract-lib": "static-1.11972",
  "invoices-highlight-card-lib": "static-1.54666",
  "orders-highlight-card-lib": "static-1.21418",
  "products-highlight-card-lib": "static-1.17777",
  "quotes-highlight-card-lib": "static-1.71949",
  "crm-source-interpretation-lib": "static-1.5329",
  "utility-belt": "static-1.2522",
  "payments-enrollment-embed-lib": "static-1.22739",
  "stripe-embedded-components": "static-1.7473",
  "customer-data-rte": "static-1.32946",
  "cv-backend-services": "static-1.1552",
  "growth-onboarding-empty-states": "static-1.5687",
  "payments-post-enroll-local-storage-lib": "static-1.5094",
  "qrcode-generator": "static-1.68",
  "quotes-client-types": "static-1.38039",
  "calling-orchestration-schema": "static-1.35688",
  "sales-views-client-types": "static-1.4251",
  "hub-http-contrib": "static-1.3029",
  "interframe": "static-3.4746",
  "tinymce-data": "static-1.40401",
  "ui-addon-sales-email": "static-1.5198",
  "layout-dnd-components": "static-1.12414",
  "layout-dnd-utils": "static-1.11389",
  "ui-brand-identity-lib": "static-1.15209",
  "NamespacedHubStyle": "static-2.9048",
  "social-insights-client-types": "static-1.22034",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4105",
  "checkout-sdk": "static-3.23609",
  "checkout-service-types": "static-1.3809",
  "company-details-components": "static-1.6185",
  "payment-method-components": "static-1.6898",
  "pricing-pages-ui-components": "static-1.13906",
  "quote-checkout-service-types": "static-1.3461",
  "upgrade-catalog-service-types": "static-1.3507",
  "access-control-lib": "static-1.10422",
  "EmailComponents": "static-1.54698",
  "EmailData": "static-1.53375",
  "redux-less": "static-2.9468",
  "sequences-lib": "static-1.8010",
  "ui-gdpr-components": "static-1.10335",
  "products-ui-components": "static-1.40012",
  "accounting-integrations-ui-components": "static-1.7037",
  "invoices-ui-lib": "static-1.54682",
  "commerce-products-api": "static-1.2261",
  "invoices-iframe-lib": "static-1.56740",
  "quotes-modal-lib": "static-1.102627",
  "quotes-ui-lib": "static-1.80670",
  "stripe-connect-js": "static-1.68",
  "draft-content-plugins": "static-1.28216",
  "ContentData": "static-1.68381",
  "layout-data-lib": "static-1.9714",
  "hub-http-rxjs": "static-1.796",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3925",
  "billing-payments-client-types": "static-1.3976",
  "react-performance-metrics-lib": "static-1.544",
  "account-and-billing-fintech-outages": "static-3.18564",
  "pricing-pages-api": "static-1.13771",
  "ContentComponents": "static-2.71262",
  "marketing-contacts-lib": "static-1.9963",
  "marketing-email-service-types": "static-1.1906",
  "messaging-editing-lib": "static-1.46216",
  "messaging-usage-based-billing-components-lib": "static-1.1078",
  "automation-ui-source-apps": "static-1.18827",
  "automation-ui-types": "static-1.19745",
  "messaging-types-lib": "static-1.45953",
  "onboarding-settings-client": "static-1.4491",
  "sequences-client-types-lib": "static-1.7867",
  "commerce-tax-lib": "static-1.513",
  "price-books-api": "static-1.613",
  "price-books-components": "static-1.671",
  "property-description-translator": "static-1.3831",
  "ramp-editor": "static-1.103",
  "commerce-analytics-service-client": "static-1.3615",
  "totals-ui-components": "static-1.23543",
  "SalesContentIndexUI": "static-3.9218",
  "advanced-menus-core": "static-1.15105",
  "advanced-menus-lib": "static-1.12048",
  "ui-memberships-settings-lib": "static-1.33995",
  "segments-query-core": "static-1.1406",
  "demographics-service-types": "static-1.1639",
  "eligibility-engine-service-types": "static-1.3171",
  "automation-ui-ubb": "static-1.5661",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7328",
  "data-token-views": "static-1.16359",
  "forms-utils-lib": "static-1.12545",
  "payments-embed-points-lib": "static-1.12994",
  "simple-menus-core": "static-1.15104",
  "simple-menus-lib": "static-1.16621",
  "ui-addon-draggable-compat": "static-2.4242",
  "videoconference-integration-components": "static-1.6796",
  "marketing-contacts-client": "static-1.7504",
  "automation-applications-service-types": "static-1.3493",
  "automation-platform-service-types": "static-1.2585",
  "ContentEditorUI": "static-2.77063",
  "short-messages-app-service-client": "static-1.3957",
  "web-interactives-components": "static-1.13730",
  "web-interactives-data": "static-1.13731",
  "messaging-shared-utils-lib": "static-1.527",
  "messaging-user-info-utils-lib": "static-1.697",
  "email-portal-health-service-types": "static-1.963",
  "line-items-api": "static-1.663",
  "commerce-totals-service-types": "static-1.3807",
  "FireAlarmUi": "static-1.4502",
  "sales-templates-service-types-lib": "static-1.4159",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21681",
  "automation-ui-usage-tracking": "static-1.21144",
  "data-studio-ubb": "static-1.2672",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26983",
  "collaboration-sidebar": "static-1.57741",
  "content-management-data-lib": "static-1.5367",
  "copilot-plugins": "static-1.11064",
  "cta-picker": "static-1.36354",
  "customer-agent-discovery-components-lib": "static-1.3034",
  "editor-components": "static-1.13208",
  "editor-iframe-lib": "static-1.8380",
  "error-messaging-js": "static-1.5179",
  "FormsCommonComponents": "static-1.85789",
  "pictos": "static-7.183",
  "react-transition-group": "static-2.64",
  "redux-request-state": "static-1.10633",
  "SharedLegalStrings": "static-1.1736",
  "smart-content-core": "static-1.42387",
  "smart-content-lib": "static-1.43040",
  "social-composer-lib": "static-1.59029",
  "structured-content-lib": "static-1.25141",
  "theme-previewer-lib": "static-1.53199",
  "tinymce-copilot": "static-1.16384",
  "xray-recommendation-lib": "static-1.7877",
  "automation-ui-routing": "static-1.21102",
  "sql-reporting-client-types": "static-1.5627",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42157",
  "campaigns-utils-lib": "static-1.3165",
  "reporting-enablement": "static-1.22855",
  "chatspot-widget-iframe": "static-1.21199",
  "collaboration-sidebar-common": "static-1.2538",
  "forms-ai-lib": "static-1.4296",
  "codemirror-dlb": "static-1.58622",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6418",
  "report-customization-components": "static-1.13110",
  "data-quality-ui-library": "static-1.12970",
  "html-to-image": "static-1.53",
  "reporting-filters": "static-1.292",
  "reporting-insights-lib": "static-1.1684"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12187",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "dashboard-client-types": "/dashboard-client-types/static-1.370",
  "data-fetching-client": "/data-fetching-client/static-1.9657",
  "foundations-components": "/foundations-components/static-1.7903",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.928",
  "foundations-theming": "/foundations-theming/static-1.4405",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.81",
  "head-dlb": "/head-dlb/static-1.4994",
  "hs-test-utils": "/hs-test-utils/static-1.8000",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9920",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "HubStyleTokens": "/HubStyleTokens/static-2.11455",
  "I18n": "/I18n/static-7.1621",
  "jasmine-runner": "/jasmine-runner/static-1.6453",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12248",
  "quartz": "/quartz/static-1.7014",
  "react-dlb": "/react-dlb/static-1.78",
  "react-rhumb": "/react-rhumb/static-1.16654",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2845",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9400",
  "settings-ui-lib": "/settings-ui-lib/static-1.12506",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7102",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11138",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9531",
  "unified-auth": "/unified-auth/static-1.475",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.757",
  "usage-tracker": "/usage-tracker/static-1-cwunder-network-layer-chunking-backpressure.8",
  "usage-tracker-core": "/usage-tracker-core/static-1-cwunder-network-layer-chunking-backpressure.8",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8075",
  "hub-http": "/hub-http/static-1.6210",
  "integrations-lib": "/integrations-lib/static-1.16061",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19653",
  "property-management-iframe": "/property-management-iframe/static-1.13082",
  "quartz-config": "/quartz-config/static-1.792",
  "quartz-core": "/quartz-core/static-1.6233",
  "quartz-routing": "/quartz-routing/static-1.444",
  "quick-fetch": "/quick-fetch/static-1.3905",
  "react": "/react/static-7.185",
  "rpc-client-utils": "/rpc-client-utils/static-1.4637",
  "ts-schema": "/ts-schema/static-1.4069",
  "ui-universal-auth": "/ui-universal-auth/static-1.8961",
  "UIComponents": "/UIComponents/static-3.8401",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.446",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "raven": "/raven/static-3.5907",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9619",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3389",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3291",
  "quartz-webpack": "/quartz-webpack/static-1.3238",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.92",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4172",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4852",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2121",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9413",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.19",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5333",
  "react-virtualized": "/react-virtualized/static-2.98",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1861",
  "ui-fonts": "/ui-fonts/static-1.717",
  "ui-images": "/ui-images/static-2.1149",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2888",
  "foundations-theming-base": "/foundations-theming-base/static-1.3390",
  "stylex": "/stylex/static-1.32",
  "HeadJS": "/HeadJS/static-2.757",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3111",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4314",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8898",
  "ai-rendering-library": "/ai-rendering-library/static-1.10088",
  "chirp-fetch": "/chirp-fetch/static-1.1872",
  "connections-embed-lib": "/connections-embed-lib/static-1.957",
  "copilot-toolkit": "/copilot-toolkit/static-1.11091",
  "feedback-loader": "/feedback-loader/static-1.29264",
  "laboratory-lib": "/laboratory-lib/static-3.7145",
  "marketplace-embed": "/marketplace-embed/static-1.22028",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9549",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19609",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13824",
  "sanitize-text": "/sanitize-text/static-1.8128",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8689",
  "usage-tracker-multi": "/usage-tracker-multi/static-1-cwunder-network-layer-chunking-backpressure.8",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-cwunder-network-layer-chunking-backpressure.8",
  "wootric-nps": "/wootric-nps/static-1.6964",
  "quartz-head": "/quartz-head/static-1.679",
  "web-vitals": "/web-vitals/static-1.4",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4636",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4141",
  "highcharts": "/highcharts/static-8.103",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2496",
  "reporting-data": "/reporting-data/static-1.67467",
  "cssUtils": "/cssUtils/static-1.787",
  "flux-actions": "/flux-actions/static-1.336",
  "HubStyle": "/HubStyle/static-2.11762",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10196",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10355",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1-cwunder-network-layer-chunking-backpressure.8",
  "icons": "/icons/static-2.645",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18186",
  "storybook-react": "/storybook-react/static-1.32",
  "trellis-story-utils": "/trellis-story-utils/static-1.4503",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5386",
  "quartz-i18n": "/quartz-i18n/static-1.689",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.180",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.298",
  "fsm": "/fsm/static-1.3718",
  "customer-data-objects": "/customer-data-objects/static-1.7652",
  "property-translator": "/property-translator/static-1.5386",
  "hs-locale-management": "/hs-locale-management/static-1.70",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7916",
  "hs-promise-utils": "/hs-promise-utils/static-1.5581",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4864",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13476",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5586",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7769",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4463",
  "superstore": "/superstore/static-1.4750",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10145",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7861",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "hubspotter-http": "/hubspotter-http/static-1.4641",
  "immutable-less": "/immutable-less/static-1.4641",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17060",
  "nav-meta": "/nav-meta/static-1.29616",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10235",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17963",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3835",
  "property-management-common": "/property-management-common/static-1.5370",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9042",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.532",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.689",
  "quartz-test": "/quartz-test/static-1.689",
  "quartz-tracking": "/quartz-tracking/static-1.393",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.47",
  "bender-build-tools": "/bender-build-tools/static-1.3186",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-cwunder-network-layer-chunking-backpressure.8",
  "usage-tracker-public": "/usage-tracker-public/static-1-cwunder-network-layer-chunking-backpressure.8",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21208",
  "ContentUtils": "/ContentUtils/static-1.68306",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13011",
  "sassPrefix": "/sassPrefix/static-1.155",
  "avatar-components": "/avatar-components/static-1.2485",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39692",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13147",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14274",
  "ExportDialog": "/ExportDialog/static-6.10378",
  "highlight.js": "/highlight.js/static-1.78",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41254",
  "reporting-snowflake": "/reporting-snowflake/static-1.56085",
  "reporting-ui-components": "/reporting-ui-components/static-2.64738",
  "reporting-visualizations": "/reporting-visualizations/static-1.59543",
  "ui-addon-teams": "/ui-addon-teams/static-1.21523",
  "magpie-lib": "/magpie-lib/static-1.5543",
  "navigation-components": "/navigation-components/static-1.17979",
  "magpie-types": "/magpie-types/static-1.5003",
  "simple-logging-lib": "/simple-logging-lib/static-1.3035",
  "ai-studio-lib": "/ai-studio-lib/static-1.11556",
  "app-governance-lib": "/app-governance-lib/static-1.1481",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10496",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7982",
  "ui-product-approvals": "/ui-product-approvals/static-1.28093",
  "ui-tool-access": "/ui-tool-access/static-1.10136",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8810",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3575",
  "persist-promise": "/persist-promise/static-1.3684",
  "reference-resolvers": "/reference-resolvers/static-1.8156",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3916",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.323",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3000",
  "final-form": "/final-form/static-1.69",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2724",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "atom": "/atom/static-1.5057",
  "purchase-motions-components": "/purchase-motions-components/static-1.5855",
  "salesImages": "/salesImages/static-1.524",
  "batch-promise": "/batch-promise/static-1.1527",
  "crm-component-utils": "/crm-component-utils/static-1.39017",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5869",
  "customer-data-properties": "/customer-data-properties/static-1.51477",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6870",
  "property-value-citations": "/property-value-citations/static-1.2091",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8080",
  "navigation-messaging": "/navigation-messaging/static-1.7306",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9918",
  "cms-field-types": "/cms-field-types/static-1.4797",
  "content-icons-ui": "/content-icons-ui/static-1.2221",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9812",
  "events-data-lib": "/events-data-lib/static-1.203",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7233",
  "crm-message-bus": "/crm-message-bus/static-1.42932",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22127",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4704",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3994",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6775",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.965",
  "onboarding-tours": "/onboarding-tours/static-1.16565",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13628",
  "academy-common-lib": "/academy-common-lib/static-1.13734",
  "content-assistance-lib": "/content-assistance-lib/static-1.7728",
  "dashboard-lib": "/dashboard-lib/static-1.81456",
  "file-manager-components": "/file-manager-components/static-1.23571",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18451",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18193",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18185",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19799",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8691",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4752",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11003",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9036",
  "user-context": "/user-context/static-1.5090",
  "growth-payments-core": "/growth-payments-core/static-1.25319",
  "reporting-plugins": "/reporting-plugins/static-1.10298",
  "reporting-reports": "/reporting-reports/static-1.67145",
  "idb-keyval": "/idb-keyval/static-1.43",
  "reactive-lib": "/reactive-lib/static-1.709",
  "nest": "/nest/static-1.212",
  "codemirror": "/codemirror/static-5.94",
  "react-codemirror": "/react-codemirror/static-1.10612",
  "framework-listing-lib": "/framework-listing-lib/static-2.28642",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30673",
  "apps-service-types": "/apps-service-types/static-1.3865",
  "oauth-service-types": "/oauth-service-types/static-1.4235",
  "onboarding-scopes": "/onboarding-scopes/static-1.6448",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4779",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7658",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14910",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3587",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9194",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5858",
  "signup-constants": "/signup-constants/static-1.18811",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8032",
  "trials-service-types": "/trials-service-types/static-1.3890",
  "card-properties-lib": "/card-properties-lib/static-1.44123",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37053",
  "crm-actions": "/crm-actions/static-1.6309",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43526",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9247",
  "customer-data-tracking": "/customer-data-tracking/static-1.6874",
  "hs-resources": "/hs-resources/static-1.142",
  "pulse": "/pulse/static-1.560",
  "calling-global-api": "/calling-global-api/static-1.64451",
  "calling-internal-common": "/calling-internal-common/static-1.31287",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65833",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58127",
  "commerce-products-lib": "/commerce-products-lib/static-1.9494",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3786",
  "crm-links": "/crm-links/static-1.6273",
  "external-options-client-types": "/external-options-client-types/static-1.4147",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4212",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.617",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3680",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48675",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3954",
  "smart-property-lib": "/smart-property-lib/static-1.6862",
  "tiered-pricing": "/tiered-pricing/static-1.1169",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10980",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4127",
  "react-dnd-compat": "/react-dnd-compat/static-1.4604",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5405",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3053",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1867",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.631",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7526",
  "academy-service-client": "/academy-service-client/static-1.3668",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39070",
  "FileManagerLib": "/FileManagerLib/static-1.39211",
  "video-embed": "/video-embed/static-1.35699",
  "zustand": "/zustand/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28498",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11207",
  "video-data-lib": "/video-data-lib/static-1.34865",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23482",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9875",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24329",
  "viral-links-lib": "/viral-links-lib/static-1.7046",
  "data-token-picker": "/data-token-picker/static-1.16378",
  "react-flip-move": "/react-flip-move/static-1.69",
  "nested-table": "/nested-table/static-1.213",
  "timezone-utils": "/timezone-utils/static-2.5230",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17569",
  "ui-addon-opt": "/ui-addon-opt/static-4.8357",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9040",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7312",
  "customer-data-views-management": "/customer-data-views-management/static-1.25418",
  "framework-data-table": "/framework-data-table/static-2.11870",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6841",
  "nudge-client-utils": "/nudge-client-utils/static-1.2530",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1003",
  "app-users-service-client": "/app-users-service-client/static-1.5583",
  "app-users-service-types": "/app-users-service-types/static-1.4991",
  "mini-checkout-client": "/mini-checkout-client/static-1.26766",
  "onboarding-utils": "/onboarding-utils/static-1.5339",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2045",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28483",
  "edison-service-client-types": "/edison-service-client-types/static-1.374",
  "crm_data": "/crm_data/static-4.91903",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45961",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15980",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19012",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18493",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10324",
  "crm-fe-perf": "/crm-fe-perf/static-1.22889",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.63",
  "directed-graph": "/directed-graph/static-1.921",
  "event-emitter": "/event-emitter/static-1.934",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "calling-error-reporting": "/calling-error-reporting/static-1.31294",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11024",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6527",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.911",
  "commerce-permissions": "/commerce-permissions/static-1.755",
  "products-iframe-lib": "/products-iframe-lib/static-1.7882",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10302",
  "data-agent-kit": "/data-agent-kit/static-1.171",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10003",
  "policy-lib": "/policy-lib/static-1.6767",
  "react-tinymce": "/react-tinymce/static-1.55190",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10066",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54316",
  "tinymce-plugins": "/tinymce-plugins/static-1.57430",
  "tinymce-themes": "/tinymce-themes/static-1.56286",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1933",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1895",
  "user-context-client": "/user-context-client/static-1.4598",
  "audio-components": "/audio-components/static-1.5892",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36722",
  "urlinator": "/urlinator/static-1.4523",
  "video-components": "/video-components/static-1.13210",
  "outpost": "/outpost/static-1.4171",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6568",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12196",
  "content-media-compositions": "/content-media-compositions/static-2.16203",
  "media-bridge-lib": "/media-bridge-lib/static-1.18896",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6063",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5068",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3627",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21644",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3829",
  "ts-utils-lib": "/ts-utils-lib/static-1.159",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.566",
  "crm-export-dialog": "/crm-export-dialog/static-1.6283",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6427",
  "crm-view-components": "/crm-view-components/static-1.181",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.29",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2287",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2606",
  "whisper-core-api": "/whisper-core-api/static-1.6566",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14763",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5475",
  "settings-content-modals": "/settings-content-modals/static-1.46023",
  "crm_universal": "/crm_universal/static-1.21977",
  "customer-data-email": "/customer-data-email/static-1.18004",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37119",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39476",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11972",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54666",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21418",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17777",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71949",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5329",
  "utility-belt": "/utility-belt/static-1.2522",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22739",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7473",
  "customer-data-rte": "/customer-data-rte/static-1.32946",
  "cv-backend-services": "/cv-backend-services/static-1.1552",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5687",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5094",
  "qrcode-generator": "/qrcode-generator/static-1.68",
  "quotes-client-types": "/quotes-client-types/static-1.38039",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35688",
  "sales-views-client-types": "/sales-views-client-types/static-1.4251",
  "hub-http-contrib": "/hub-http-contrib/static-1.3029",
  "interframe": "/interframe/static-3.4746",
  "tinymce-data": "/tinymce-data/static-1.40401",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5198",
  "layout-dnd-components": "/layout-dnd-components/static-1.12414",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11389",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15209",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9048",
  "social-insights-client-types": "/social-insights-client-types/static-1.22034",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4105",
  "checkout-sdk": "/checkout-sdk/static-3.23609",
  "checkout-service-types": "/checkout-service-types/static-1.3809",
  "company-details-components": "/company-details-components/static-1.6185",
  "payment-method-components": "/payment-method-components/static-1.6898",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13906",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3461",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3507",
  "access-control-lib": "/access-control-lib/static-1.10422",
  "EmailComponents": "/EmailComponents/static-1.54698",
  "EmailData": "/EmailData/static-1.53375",
  "redux-less": "/redux-less/static-2.9468",
  "sequences-lib": "/sequences-lib/static-1.8010",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10335",
  "products-ui-components": "/products-ui-components/static-1.40012",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7037",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54682",
  "commerce-products-api": "/commerce-products-api/static-1.2261",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56740",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102627",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80670",
  "stripe-connect-js": "/stripe-connect-js/static-1.68",
  "draft-content-plugins": "/draft-content-plugins/static-1.28216",
  "ContentData": "/ContentData/static-1.68381",
  "layout-data-lib": "/layout-data-lib/static-1.9714",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.796",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3925",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3976",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.544",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18564",
  "pricing-pages-api": "/pricing-pages-api/static-1.13771",
  "ContentComponents": "/ContentComponents/static-2.71262",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9963",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1906",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46216",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1078",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18827",
  "automation-ui-types": "/automation-ui-types/static-1.19745",
  "messaging-types-lib": "/messaging-types-lib/static-1.45953",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4491",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7867",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.513",
  "price-books-api": "/price-books-api/static-1.613",
  "price-books-components": "/price-books-components/static-1.671",
  "property-description-translator": "/property-description-translator/static-1.3831",
  "ramp-editor": "/ramp-editor/static-1.103",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3615",
  "totals-ui-components": "/totals-ui-components/static-1.23543",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9218",
  "advanced-menus-core": "/advanced-menus-core/static-1.15105",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12048",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33995",
  "segments-query-core": "/segments-query-core/static-1.1406",
  "demographics-service-types": "/demographics-service-types/static-1.1639",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3171",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5661",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7328",
  "data-token-views": "/data-token-views/static-1.16359",
  "forms-utils-lib": "/forms-utils-lib/static-1.12545",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12994",
  "simple-menus-core": "/simple-menus-core/static-1.15104",
  "simple-menus-lib": "/simple-menus-lib/static-1.16621",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4242",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6796",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7504",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3493",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2585",
  "ContentEditorUI": "/ContentEditorUI/static-2.77063",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3957",
  "web-interactives-components": "/web-interactives-components/static-1.13730",
  "web-interactives-data": "/web-interactives-data/static-1.13731",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.527",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.697",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.963",
  "line-items-api": "/line-items-api/static-1.663",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3807",
  "FireAlarmUi": "/FireAlarmUi/static-1.4502",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4159",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21681",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21144",
  "data-studio-ubb": "/data-studio-ubb/static-1.2672",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26983",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57741",
  "content-management-data-lib": "/content-management-data-lib/static-1.5367",
  "copilot-plugins": "/copilot-plugins/static-1.11064",
  "cta-picker": "/cta-picker/static-1.36354",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3034",
  "editor-components": "/editor-components/static-1.13208",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8380",
  "error-messaging-js": "/error-messaging-js/static-1.5179",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85789",
  "pictos": "/pictos/static-7.183",
  "react-transition-group": "/react-transition-group/static-2.64",
  "redux-request-state": "/redux-request-state/static-1.10633",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1736",
  "smart-content-core": "/smart-content-core/static-1.42387",
  "smart-content-lib": "/smart-content-lib/static-1.43040",
  "social-composer-lib": "/social-composer-lib/static-1.59029",
  "structured-content-lib": "/structured-content-lib/static-1.25141",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53199",
  "tinymce-copilot": "/tinymce-copilot/static-1.16384",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7877",
  "automation-ui-routing": "/automation-ui-routing/static-1.21102",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5627",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42157",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3165",
  "reporting-enablement": "/reporting-enablement/static-1.22855",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21199",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2538",
  "forms-ai-lib": "/forms-ai-lib/static-1.4296",
  "codemirror-dlb": "/codemirror-dlb/static-1.58622",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6418",
  "report-customization-components": "/report-customization-components/static-1.13110",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12970",
  "html-to-image": "/html-to-image/static-1.53",
  "reporting-filters": "/reporting-filters/static-1.292",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1684"
}
};
